import React from 'react';
import { Form, Select } from 'antd';
import { selectInputFilterHelper } from '@common/services';
import { RoleType, RoleFlatType } from '@clinician-profile/graphql';

type RoleSelectProps = {
  disabled?: boolean;
  roles?: RoleType[] | RoleFlatType[];
  showLabel?: boolean;
  labelKey?: 'abbreviation' | 'name';
  placeholder?: string;
  size?: 'large' | 'middle' | 'small';
};

export function RoleSelect({
  roles,
  disabled = false,
  showLabel = true,
  labelKey = 'abbreviation',
  placeholder = 'Select role',
  size = 'large',
  ...props
}: RoleSelectProps) {
  return (
    <Form.Item
      name="roleId"
      label={showLabel && 'Role'}
      colon={false}
      rules={[{ required: true, message: 'Please select a role' }]}
    >
      <Select
        showSearch
        size={size}
        disabled={disabled}
        placeholder={placeholder}
        filterOption={selectInputFilterHelper}
        getPopupContainer={(trigger) => trigger.parentNode}
        {...props}
      >
        {roles?.map((role) => {
          const label = role[labelKey];
          return (
            <Select.Option key={role.id} value={role.id} label={label}>
              {label}
            </Select.Option>
          );
        })}
      </Select>
    </Form.Item>
  );
}
